import { handleResponse } from './handleresponse'
import { apiurl } from '@/services/config'
const API_URL = apiurl

export const MemberBankServices = {
  getMemberBanks,
  addMemberbanks,
  cekBank,
  updateMemberbank,
  deleteMemberbank,
  doCashout,
  getOTP,
  getMemberBanksCashout,
  getOTPProfile
}
function getOTPProfile (phone) {
  return fetch(API_URL + '/api/v1/otpprofile?phone=' + phone, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}
function getOTP () {
  return fetch(API_URL + '/api/v1/otp', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function doCashout (postdata) {
  return fetch(API_URL + '/api/v1/seller/cashout', {
    method: 'POST',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function deleteMemberbank (id) {
  return fetch(API_URL + '/api/v1/seller/banks/' + id, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function cekBank (postdata) {
  return fetch(API_URL + '/api/v1/seller/banks/cek', {
    method: 'POST',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}
function updateMemberbank (postdata) {
  return fetch(API_URL + '/api/v1/seller/banks', {
    method: 'PATCH',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function addMemberbanks (postdata) {
  return fetch(API_URL + '/api/v1/seller/banks', {
    method: 'POST',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}
function getMemberBanks () {
  return fetch(API_URL + '/api/v1/seller/banks', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function getMemberBanksCashout (amount) {
  return fetch(API_URL + '/api/v1/seller/cashout/bank/' + amount, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}
